import {Component, OnInit} from '@angular/core';  
import {LoggerService} from '@app/services/logger.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantService } from '@app/services/tenant.service'; 
import {EnvironmentsEnum} from '@app/shared/enums/environments.enum';
import { AbstractViewComponent } from '@app/onboarding/views/abstract-components/abstract-view';
import { environment } from 'environments/environment';
import {Store} from '@ngrx/store';
import {AuthActions, AuthState, OnboardingState} from '@app/state';
import { LinksEnum } from '@app/shared/enums/links.enum';

// @Component({
//   selector: 'download-component',
//   template:
//     ` <div fxFlexFill fxLayoutAlign="center center">
//     <span class="mat-display-4">Logged out.</span>
//   </div>`,
// })

@Component({
  selector: 'download-component',
  templateUrl: 'deeplink.component.html',
  styleUrls: ['deeplink.component.scss'],
})

export class DeepLinkComponent extends AbstractViewComponent {
  submit(): void {
    throw new Error('Method not implemented.');
  }
  env = environment.tenant;
  envEnum = EnvironmentsEnum.mcInroy;

  heading =
    this.env !== this.envEnum
      ? 'Congratulations! You can now activate your account.'
      : 'Thank you for completing your application';
  description =
    'To activate your account we need to verify your identity and address using our app. We have sent you an email with the details.';
  deeplinkId: string = null;
  deeplinkStatus: string = null;
  appStoreUrl = environment.appStore.appStoreUrl;
  playStoreUrl = environment.appStore.playStoreUrl;
  mobileFaqLink = this.env !== this.envEnum ? LinksEnum.MobileFAQ : 'https://www.mcinroy-wood.co.uk/';
  constructor(
    private route: ActivatedRoute,
    public logger: LoggerService,
    public tenantService: TenantService,
    private router: Router,
        protected onboardingStore: Store<OnboardingState.OnboardingState>,
    
  ) {
    super(onboardingStore);
  }
  ngOnInit(): void {
     
  }
}
